const DS_INDIGO_FONT_FAMILY = '"DS Indigo",DSIndigo,Helvetica,Arial,sans-serif'

const tokens = {
  body: DS_INDIGO_FONT_FAMILY,
  heading: DS_INDIGO_FONT_FAMILY,
} as const

export default tokens
